// extracted by mini-css-extract-plugin
module.exports = {"root":"eventDetails_root__oNeL_","title":"eventDetails_title__giPop","live":"eventDetails_live__3sluc"};